"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sassuolo": {
    "af3555e8": [{
      "hkey": "16cabf26",
      "slug": "ancora-borgo-venezia",
      "name": "Ancora-Borgo Venezia",
      "primary": true,
      "skipSearch": false
    }],
    "ancora": [{
      "hkey": "16cabf26",
      "slug": "ancora-borgo-venezia",
      "name": "Ancora-Borgo Venezia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sassuolo"
    }],
    "7862d5d9": [{
      "hkey": "16cabf26",
      "slug": "ancora-borgo-venezia",
      "name": "Ancora-Borgo Venezia",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-venezia": [{
      "hkey": "16cabf26",
      "slug": "ancora-borgo-venezia",
      "name": "Ancora-Borgo Venezia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sassuolo"
    }],
    "5e267dce": [{
      "hkey": "24e6294f",
      "slug": "sassuolo",
      "name": "Sassuolo",
      "primary": true,
      "skipSearch": false
    }],
    "le-muraglie": [{
      "hkey": "24e6294f",
      "slug": "sassuolo",
      "name": "Sassuolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eca94715": [{
      "hkey": "db16fffb",
      "slug": "madonna-di-sotto-quattroponti",
      "name": "Madonna di Sotto-Quattroponti",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-di-sotto": [{
      "hkey": "db16fffb",
      "slug": "madonna-di-sotto-quattroponti",
      "name": "Madonna di Sotto-Quattroponti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sassuolo"
    }],
    "3e68503f": [{
      "hkey": "24e6294f",
      "slug": "sassuolo",
      "name": "Sassuolo",
      "primary": true,
      "skipSearch": false
    }],
    "pista": [{
      "hkey": "24e6294f",
      "slug": "sassuolo",
      "name": "Sassuolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c6470d84": [{
      "hkey": "db16fffb",
      "slug": "madonna-di-sotto-quattroponti",
      "name": "Madonna di Sotto-Quattroponti",
      "primary": true,
      "skipSearch": false
    }],
    "quattroponti": [{
      "hkey": "db16fffb",
      "slug": "madonna-di-sotto-quattroponti",
      "name": "Madonna di Sotto-Quattroponti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sassuolo"
    }],
    "6b103931": [{
      "hkey": "24e6294f",
      "slug": "sassuolo",
      "name": "Sassuolo",
      "primary": true,
      "skipSearch": false
    }],
    "rocca": [{
      "hkey": "24e6294f",
      "slug": "sassuolo",
      "name": "Sassuolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9961f71d": [{
      "hkey": "24e6294f",
      "slug": "sassuolo",
      "name": "Sassuolo",
      "primary": true,
      "skipSearch": false
    }],
    "villa-segre": [{
      "hkey": "24e6294f",
      "slug": "sassuolo",
      "name": "Sassuolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "14ec250f": [{
      "hkey": "db16fffb",
      "slug": "madonna-di-sotto-quattroponti",
      "name": "Madonna di Sotto-Quattroponti",
      "primary": true,
      "skipSearch": false
    }],
    "villaggio-artigiano": [{
      "hkey": "db16fffb",
      "slug": "madonna-di-sotto-quattroponti",
      "name": "Madonna di Sotto-Quattroponti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sassuolo"
    }]
  }
};
exports["default"] = _default;